import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

import { HTTP } from "../../api/http-common";
import { useNavigate, Link } from "react-router-dom";
import Pagination from '../../component/pagination';
import CouponList from '../../pages/Admin/CouponList';
import CouponModal from '../../component/CouponModal';
import { useGlobalContext } from "../../component/GlobalContext";
import VendorDetails from "../Vendor/VendorDetails";
import { PlusIcon, SearchIcon } from "lucide-react";

function AdminCoupon() {
  const { globalUserVar, isAuthenticated, setIsAuthenticated } = useGlobalContext();
  const access_token = (localStorage.getItem('access_token'));
  const [coupons, setCoupons] = useState([]);
  const [filteredCoupons, setFilteredCoupons] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({ page: '1', limit: '10' });
  const [showModal, setShowModal] = useState(false); // State to manage modal visibility
  const [search, setSearch] = useState({ search_value: '' });
  const [searchValue, setSearchValue] = useState('');
  const [vendorAddresses, setVendorAddresses] = useState([]);
  const [vendorDetail, setVendorDetail] = useState([]);
  const [role, setRole] = useState("");
  useEffect(() => {
    // console.log('here');
    if (isAuthenticated) {
      let userObj = localStorage.getItem('userObj');
      if (userObj != null && userObj !== "") {
        let userJson = JSON.parse(userObj);
        setRole(userJson.role.name)
        setVendorDetail(userJson.vendor_detail)
      }
    }
  }, [isAuthenticated]);

  const [formData, setFormData] = useState({
    id: 0,
    coupon_code: "",
    coupon_type: 1,
    coupon_addresses: [],
    coupon_selected_addresses: [],
    coupon_value: "",
    minimum_purchase: "",
    maximum_uses: "",
    start_date: "",
    expiration_date: "",
    description: "",
    status: true,
  });

  useEffect(() => {
    // console.log(showModal)
    if (!showModal) {
      setFormData((prevData) => ({
        ...prevData,
        id: 0,
        coupon_code: "",
        coupon_type: 1,
        coupon_addresses: [],
        coupon_selected_addresses: [],
        coupon_value: "",
        minimum_purchase: "",
        maximum_uses: "",
        start_date: "",
        expiration_date: "",
        description: "",
        status: true,
      }));
    }
  }, [showModal]);


  const fetchCoupons = async (couponData) => {
    let config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    }
    let fields = {
      filters: {
        search_value: search.search_value,
        coupon_type: filterType
      },
      pagination: pagination,
      sorting: { field: 'id', type: 'desc' },
    };
    HTTP.post('coupon/get_coupons', fields, config)
      .then((response) => {
        const data = response.data;
        if (response.status === 200) {
          setFilteredCoupons(data.contents);
          setTotal(data.total_count);
        }
        if (response.status === 204) {
          // setAaMasters([])
        }
      })
      .catch((error) => {
        setError(error)
        // setRerenderFlag(true);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  };

  const loadvendor = async () => {
    HTTP.get("vendors/profile/info/" + vendorDetail.id)
      .then((response) => {
        if (response.status === 200) {
          setVendorAddresses(response.data.vendor_addresses);
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          // Handle unauthorized error
        }
      });
  };
  useEffect(() => {
    if (vendorDetail.id) {
      loadvendor();
    }
  }, [vendorDetail]);
  useEffect(() => {
    fetchCoupons();
  }, [searchQuery, filterType, currentPage, pagination]); // Add coupons to the dependency array
  // }, [searchQuery, filterType,currentPage,pagination]);  // Add coupons to the dependency array

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const onSearchEnter = (value) => {
    if (value.length == 0 || value.length >= 3) {
      setSearch({ ...search, search_value: value });
      setPagination({ ...pagination, page: 1, limit: (pagination.limit) });
    }
  };

  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
  };

  const convertToISODate = (dateString) => {
    const date = new Date(dateString); // Parse the input string into a Date object
    const year = date.getFullYear(); // Get the year
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based, pad to 2 digits
    const day = String(date.getDate()).padStart(2, '0'); // Pad day to 2 digits
    return `${year}-${month}-${day}`; // Format as Y-m-d
  };

  const editCoupon = (coupon) => {
    console.log(coupon.addresses)
    // const date = new Date(coupon.start_date);
    // const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    // console.log(formattedDate)

    setFormData((prevData) => ({
      ...prevData,
      id: coupon.id,
      coupon_code: coupon.coupon_code,
      coupon_type: coupon.coupon_type,
      coupon_value: coupon.coupon_value,
      minimum_purchase: coupon.minimum_purchase,
      maximum_uses: coupon.maximum_uses,
      start_date: convertToISODate(coupon.start_date),
      expiration_date: convertToISODate(coupon.expiration_date),
      description: coupon.description,
      status: coupon.status,
      coupon_selected_addresses: coupon.addresses,
    }));

    setShowModal(true);
  }

  const toggleStatus = async (couponCode, currentStatus) => {
    // Check if couponCode is valid
    if (!couponCode) {
      console.error("Deal Code is invalid or undefined.");
      return;
    }

    // Use SweetAlert for confirmation
    const isConfirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You are about to update the Deal status.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    });

    if (!isConfirmed.isConfirmed) return;

    try {
      const response = await HTTP.put(
        `/coupon/${couponCode}/toggle_status` // Use couponCode in the URL
      );
      console.log("Response Data:", response.data); // Debugging
      setCoupons((prevCoupons) =>
        prevCoupons.map((coupon) =>
          coupon.coupon_code === couponCode ? { ...coupon, status: response.data.status } : coupon
        )
      );
      // Show a success alert after updating the status
      Swal.fire("Updated!", "The coupon status has been updated.", "success");
      fetchCoupons();
    } catch (error) {
      console.error("Error:", error); // Debugging
      setError("Error updating coupon status.");
      // Show an error alert in case of failure
      Swal.fire("Error", "There was an error updating the coupon status.", "error");
    }
  };



  // if (loading) return <p>Loading coupons...</p>;
  if (error) return <p>{error}</p>;


  const onPaginationChange = (page) => {
    // alert('here')
    setPagination({ ...pagination, page });
  };
  const onLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setPagination({ ...pagination, limit: newLimit, page: 1 });
  };


  return (
    <div className="admin-table-container container mx-auto">
      <CouponModal showModal={showModal} setShowModal={setShowModal} formData={formData} setFormData={setFormData} fetchCoupons={fetchCoupons} vendorAddresses={vendorAddresses} />
      <div className="admin-table-header">
        <div className=" flex justify-between">
          <h2 className="text-[28px] font-medium  pb-2">
            Deals
          </h2>
          <div className="">
            {role === "Vendor" && (
              <button
                className="rounded-lg font-semibold theme-button bg-white px-4 py-2 flex"
                onClick={() => setShowModal(true)}
              >
                <span className="pr-1"> Add Deal </span>
                <PlusIcon className="w-5 " />
              </button>
            )}
          </div>
        </div>

        {/* display: flex;
	justify-content: space-between;
	align-items: center; */}
        <div className="flex justify-between items-center">
          <div className="w-1/2 flex">
            <div className=" w-1/2 border-b border-gray-300 mr-6 ">
              <div className="flex items-center">
                <span className="w-4">
                  <SearchIcon className="w-4" />
                </span>
                <input
                  type="text"
                  placeholder="Search Deals"
                  className="admin-table-search-input w-full"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') { onSearchEnter(e.target.value) } }}
                />
              </div>
            </div>
            <div className="w-1/2 border-b border-gray-300">
              <select
                className="admin-table-filter-dropdown w-full"
                value={filterType}
                onChange={handleFilterChange}
              >
                <option value="all">All Types</option>
                <option value="amount">Amount</option>
                <option value="percentage">Percentage</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Start to fetch the data */}
      <div className="custom-overflow-wrapper admin-table-custom-overflow-wrapper p-[20px] px-[17px] rounded-[12px] border border-gray-300 bg-[#ffffff]">
        <table className="admin-table-table admin-table-custom-overflow-table rounded-2xl">
          <thead className="admin-table-custom-overflow-thead">
            <tr>
              <th className="admin-table-th">Code</th>
              {role === "Admin" && <th className="admin-table-th">Vendor</th>}
              <th className="admin-table-th">Type</th>
              <th className="admin-table-th">Value</th>
              <th className="admin-table-th">Min. Purchase</th>
              <th className="admin-table-th">Usage Limit</th>
              <th className="admin-table-th">Usage Count</th>
              <th className="admin-table-th">Start Date</th>
              <th className="admin-table-th">Expiration</th>
              <th className="admin-table-th">Description</th>
              <th className="admin-table-th">Status</th>
              <th className="admin-table-th">Action</th>
            </tr>
          </thead>
          <tbody className="admin-table-custom-overflow-tbody">
            {Array.isArray(filteredCoupons) && filteredCoupons.length > 0 ? (
              filteredCoupons.map((coupon) => (
                <CouponList
                  key={coupon.id}
                  coupon={coupon}
                  handleStatusChange={toggleStatus}
                  handleEditCoupon={editCoupon}
                  role={role}
                  fetchCoupons={fetchCoupons}
                />
              ))
            ) : (
              <tr>
                <td className="admin-table-td" colSpan="11">No data found</td>
              </tr>
            )}
          </tbody>
        </table>
        {Array.isArray(filteredCoupons) && filteredCoupons.length > 0 ? (
          <Pagination total={total} pagination={pagination} handlePageChange={onPaginationChange} handleLimitChange={onLimitChange} />
        ) : (
          null
        )}
      </div>


    </div>
  );
}

export default AdminCoupon;
